import { useEffect, useState } from "react"

/** "0:42" style label for a scheduled breakout end, updated every second; null once it passes or when unset. */
export const formatCountdown = (remainingMs: number) => {
  const total = Math.max(0, Math.ceil(remainingMs / 1000))
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes}:${String(seconds).padStart(2, "0")}`
}

export function useBreakoutCountdown(endsAt: number | null): string | null {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (endsAt === null) return
    setNow(Date.now())
    const interval = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(interval)
  }, [endsAt])
  if (endsAt === null) return null
  return formatCountdown(endsAt - now)
}
